// extracted by mini-css-extract-plugin
module.exports = {"link":"ProductLink_link__fmBOF"};